'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MessageBoxFunctionalLayout = require('wix-style-react/dist/src/MessageBox/MessageBoxFunctionalLayout');

var _MessageBoxFunctionalLayout2 = _interopRequireDefault(_MessageBoxFunctionalLayout);

var _Button = require('wix-style-react/dist/src/Button');

var _Button2 = _interopRequireDefault(_Button);

var _sellerTypesIcons = require('../sellerTypesIcons.js');

var _sellerTypesIcons2 = _interopRequireDefault(_sellerTypesIcons);

var _changeProviders = require('./changeProviders.scss');

var _changeProviders2 = _interopRequireDefault(_changeProviders);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cx = _bind2.default.bind(_changeProviders2.default);

/* eslint-disable react/prop-types */

var ProviderConfirmationAlert = function (_Component) {
  (0, _inherits3.default)(ProviderConfirmationAlert, _Component);

  function ProviderConfirmationAlert() {
    (0, _classCallCheck3.default)(this, ProviderConfirmationAlert);
    return (0, _possibleConstructorReturn3.default)(this, (ProviderConfirmationAlert.__proto__ || (0, _getPrototypeOf2.default)(ProviderConfirmationAlert)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProviderConfirmationAlert, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          provider = _props.provider,
          onClose = _props.onClose,
          onOk = _props.onOk,
          t = _props.t;
      var languageKeys = provider.languageKeys,
          sellerType = provider.sellerType,
          preventTOU = provider.preventTOU,
          termsOfUseLink = provider.termsOfUseLink;
      var termsOfUse = languageKeys.termsOfUse,
          youveChosenKey = languageKeys.youveChosenKey,
          changeProviderAlertKey = languageKeys.changeProviderAlertKey;

      var icon = _sellerTypesIcons2.default[sellerType];
      var selectionPromptFooterClassname = cx(_changeProviders2.default.selectionPromptFooter, preventTOU ? _changeProviders2.default.widthoutBottomBar : null);

      var bottomBar = null;
      if (!preventTOU) {
        bottomBar = _react2.default.createElement(
          'div',
          { className: _changeProviders2.default.selectionPromptBottomBar },
          _react2.default.createElement(
            'span',
            { className: _changeProviders2.default.text },
            t.getByKey('ChangeProvider_Switching_PopUp_OAP_Agreement_Text'),
            '\xA0',
            _react2.default.createElement(
              'a',
              { href: termsOfUseLink, target: '_blank', className: _changeProviders2.default.link },
              t.getByKey(termsOfUse)
            ),
            ' ',
            t.getByKey('ChangeProvider_Switching_PopUp_OAP_Agreement_Text2'),
            ' '
          ),
          '\xA0',
          _react2.default.createElement(
            'a',
            {
              href: 'https://progallery.wixapps.net/terms.html',
              target: '_blank',
              className: _changeProviders2.default.link
            },
            t.getByKey('ChangeProvider_Switching_PopUp_OAP_Agreement_Terms_WIX_Link')
          )
        );
      }
      return _react2.default.createElement(
        _MessageBoxFunctionalLayout2.default,
        {
          theme: 'blue',
          title: _react2.default.createElement(
            'span',
            null,
            t.getByKey(youveChosenKey)
          ),
          onCancel: onClose,
          hideFooter: true
        },
        _react2.default.createElement(
          'div',
          { className: _changeProviders2.default.selectionPromptContent },
          icon,
          _react2.default.createElement(
            'span',
            null,
            t.getByKey(changeProviderAlertKey)
          )
        ),
        _react2.default.createElement(
          'div',
          { className: selectionPromptFooterClassname },
          _react2.default.createElement(
            'div',
            { className: _changeProviders2.default.actionButton },
            _react2.default.createElement(
              _Button2.default,
              { height: 'small', onClick: onClose, theme: 'transparentblue' },
              t.getByKey('ChangeProvider_Switching_PopUp_OAP_Cancel_Label')
            )
          ),
          _react2.default.createElement(
            'div',
            { className: _changeProviders2.default.actionButton },
            _react2.default.createElement(
              _Button2.default,
              { height: 'small', onClick: function onClick() {
                  return onOk(provider);
                } },
              t.getByKey('ChangeProvider_Switching_PopUp_OAP_OK_Label')
            )
          )
        ),
        bottomBar
      );
    }
  }]);
  return ProviderConfirmationAlert;
}(_react.Component);
/* eslint-enable react/prop-types */

ProviderConfirmationAlert.propTypes = {};

exports.default = ProviderConfirmationAlert;